module.exports = __webpack_public_path__ + "img/invitebtn.c0b5aebc.png";